import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-foo',
  template: `<p>
  foo works!
</p>
`,
  styles: [``]
})
export class FooComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
